import React, { useState } from 'react';
import './ModernNavigation.css';

interface ModernNavigationProps {
  scrolled?: boolean;
}

export const ModernNavigation: React.FC<ModernNavigationProps> = ({ scrolled = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className={`modern-nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="container nav-container">
        <div className="nav-brand">
          <a href="/" className="brand-link">
            <img src="/ew-color-logo_crop.png" alt="EquityWorkx" className="brand-logo" />
          </a>
        </div>
        
        <nav className="nav-menu desktop-menu">
          <a href="/features" className="nav-link">Features</a>
          <a href="/how-it-works" className="nav-link">How It Works</a>
          <a href="/download" className="nav-link">Download</a>
        </nav>
        
        <div className="nav-actions">
          <a href="/agent/login" className="nav-link agent-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span>Agent Portal</span>
          </a>
          <a href="/download" className="btn btn-primary btn-sm nav-cta">
            Get Started
          </a>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <a href="/features" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            Features
          </a>
          <a href="/how-it-works" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            How It Works
          </a>
          <a href="/download" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            Download
          </a>
          <div className="mobile-nav-divider"></div>
          <a href="/agent/login" className="mobile-nav-link agent" onClick={() => setMobileMenuOpen(false)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            Agent Portal
          </a>
          <a href="/download" className="btn btn-primary btn-lg mobile-cta" onClick={() => setMobileMenuOpen(false)}>
            Get Started Free
          </a>
        </nav>
      </div>
    </header>
  );
};